"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToClipboardStyling = void 0;
var _react = _interopRequireDefault(require("react"));
var _ReadinessCheckerMessaging = require("../ReadinessCheckerMessaging.styled");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactCopyToClipboard = require("react-copy-to-clipboard");
var _reactstrap = require("reactstrap");
var _propTypes = require("prop-types");
var CopyToClipboardStyling = exports.CopyToClipboardStyling = function CopyToClipboardStyling(_ref) {
  var title = _ref.title,
    content = _ref.content,
    learnMoreLink = _ref.learnMoreLink,
    urls = _ref.urls;
  var textToCopy = "Hello, I got some problems with network traffic. These ports are blocked: ".concat(urls.join(', '));
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerMessaging.StyledMessagingWrapper, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u2022 \xA0 ", title), /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerMessaging.StyledClipboardWrapper, null, /*#__PURE__*/_react["default"].createElement("div", null, content, learnMoreLink && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerMessaging.StyledLinkText, {
    href: learnMoreLink,
    target: "_blank",
    "data-testid": "learn-more-link"
  }, "Learn more"), /*#__PURE__*/_react["default"].createElement("a", {
    href: learnMoreLink,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "text-primary",
    icon: _freeSolidSvgIcons.faUpRightFromSquare
  })))), /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerMessaging.StyledUrlContainer, null, urls.map(function (url) {
    return /*#__PURE__*/_react["default"].createElement(_ReadinessCheckerMessaging.StyledUrlText, {
      key: url
    }, url);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-md-end"
  }, /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
    text: textToCopy
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Button, {
    size: "sm",
    color: "dark",
    outline: true
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCopy
  }), " Copy")))));
};
CopyToClipboardStyling.propTypes = {
  title: _propTypes.string,
  content: _propTypes.string,
  learnMoreLink: _propTypes.string,
  urls: _propTypes.array.isRequired
};